import * as React from "react";
import { NotificationContainer } from "react-notifications";

import Footer from "./Footer";
import Nav from "./Nav";
import Toolbox from "./toolbox/Toolbox";

class App extends React.Component<{}, {}> {
    render(): JSX.Element {
        return (
            <div>
                <NotificationContainer />
                <Nav />
                <div className="root-container container">
                    <Toolbox />
                </div>
                <Footer />
            </div>
        );
    }
}

export default App;
